/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState } from 'react'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { makeStyles } from '@mui/styles';
import { Grid, Typography, Button, TextField, ListItemText, ListItemIcon, ListItem, IconButton, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { portalCfg } from '../../config';
import CustomDivider from '../../components/CustomDivider';
import CustomHeader from '../../components/CustomHeader';
import { getAppConfig, getLogo } from '../../utils/commons';
import { usage_type } from '../../services/wsclients/dataUtil';
import CustomAlert from '../../components/CustomAlert';
import TermConditionController from '../term-condition/TermConditionController';
import CustomFooter from '../../components/CustomFooter';
import { PlaceIcon } from '../../components/CustomIcons';
import { HashLink } from 'react-router-hash-link';
import useGoogle from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import classNames from 'classnames';
import ListAddresses from './ListAddresses';
import CustomModal from '../../components/CustomModal';
import OneMapWidget from '../../components/OneMapWidget';
import theme from '../../theme.css';
import Container from '../../components/Container';
import SimpleSteps, { useSteps } from '../../components/SimpleSteps';
import { STEPS_REGISTER, steps } from '../../utils/util';
import RegisterControllerV2 from '../register/RegisterControllerV2';
import StepHeader from '../../components/StepHeader';
import PackageInfoController from '../package-info/PackageInfoController';
import OrderCompleteView from '../register/OrderCompleteView';
import PaymentSetupView from '../register/PaymentSetupView';
import PlaceOrderView from '../register/PlaceOrderView';
import ChooseBillingDate from '../register/ChooseBillingDate';
import PlaceOrderController from '../register/PlaceOrderController';
import RegisterControllerV3 from '../register/RegisterControllerV3';


const useStyles = makeStyles((theme) => ({
    top: {
        margin: theme.spacing(10) + ' ' + theme.spacing(3)
    },
    bottom: {
        margin: theme.spacing(10) + ' ' + theme.spacing(3)
    },
    package: {
        cursor: 'pointer',
        width: '90%',
        height: 400,
        [theme.breakpoints.up('sm')]: {
            width: '80%',
            height: 400,
        },
        [theme.breakpoints.up('md')]: {
            width: '80%',
        },
        [theme.breakpoints.up('lg')]: {
            width: '94%',
        },
        [theme.breakpoints.up('xl')]: {
            width: '90%',
        },
    },
    item_image: {
        display: 'block',
        margin: 'auto',
        width: '100%',
    },
    item_image_logo: {
        width: '100%',
        height: 300,
        objectFit: 'contain',
    },
    img_cant_select: {
        filter: 'blur(0px) grayscale(100%)'
    },
    term_condition: {
        cursor: 'pointer'
    },
    address_item: {
        cursor: 'pointer',
        padding: theme.spacing(1),
        borderBottom: '1px solid ' + theme.palette.background.primary,
    },
    address_selected: {
        backgroundColor: theme.palette.background.primary,
    },
    canSelected: {
        cursor: 'pointer',
    },
    cantSelected: {
        opacity: 0.5,
    },
    select_container: {
        marginTop: theme.spacing(0.4)
    },
    select_input: {
        padding: '10.5px 18.5px 10.5px 18.5px!important',
        backgroundColor: theme.palette.common.white,
    },
    input: {
        border: '1px solid',
        borderColor: theme.palette.border.main,
        borderRadius: theme.spacing(2),
        // height: '42px',
        padding: theme.spacing(1) + ' 0',
        width: '100%',
    },
    input_container: {
        border: '1px solid',
        borderColor: theme.palette.border.main,
        borderRadius: theme.spacing(2),
        // height: '42px',
        padding: theme.spacing(1) + ' 0',
        width: '100%',
    },
    inputContainerFocus: {
        border: 'none',
    },
    inputRoot: {
        //color: theme.palette.common.white + "!important",
        padding: '10.5px 18.5px 10.5px 18.5px!important',
        background: theme.palette.common.white
    },
    textArea: {
        // minHeight: theme.spacing(24),
        height: 'auto',
    },
    //add css underline, 
    underline: {
        "&&&:before": {
            borderBottom: "none"
        },
        "&&:after": {
            borderBottom: "none"
        }
    },
    search_by: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    item_address: {
        padding: theme.spacing(1, 2),
    },
    list_item: {
        position: "absolute",
        background: "#eee",
        width: '100%',
        zIndex: 10,
        maxHeight: 200,
        overflow: 'auto'
    }
}));

export default function LandingPageV2View(props) {
    console.log('LandingPageView props: ', props);
    const { palette } = useTheme();
    const { t } = useTranslation();
    const classes = useStyles();
    const packagesRef = useRef(null);
    const items = [
        portalCfg.publicPath + "/images/banner/header_one.jpg",
        portalCfg.publicPath + "/images/banner/header_two.jpg"
    ]
    const { showModal, setShowModal, setChoosePackage, showTerm, showListAddresses, setShowListAddresses, choosePackage, packages, onSetBuildingSelected, openModalBuilding, onCloseModalBuilding, building } = props;

    const appConfig = getAppConfig();
    const content = appConfig && appConfig.about_details && appConfig.about_details.terms_conditions && appConfig.about_details.terms_conditions.content ? appConfig.about_details.terms_conditions.content : null;
    const urlTerm = appConfig && appConfig.about_details && appConfig.about_details.terms_conditions && appConfig.about_details.terms_conditions.url ? appConfig.about_details.terms_conditions.url : null;
    const carousels = appConfig && appConfig.creatives && appConfig.creatives.length > 0 ? appConfig.creatives.filter(x => x.usage_type === usage_type.carousel_image) : null;
    // console.log("choosePackage ===", choosePackage);

    useEffect(() => {
        if (!showModal && packages) {
            let section;

            if (packages.productflylites && packages.productflylites.length > 0) {
                for (let i = 0; i < packages.productflylites.length; i++) {
                    let p = packages.productflylites[i];
                    if (p.is_available) {
                        section = document.getElementById('section-product-flylite');
                        break;
                    }
                }
            }

            if (!section && packages.productflysmarts && packages.productflysmarts.length > 0) {
                for (let i = 0; i < packages.productflysmarts.length; i++) {
                    let p = packages.productflysmarts[i];
                    if (p.is_available) {
                        section = document.getElementById('section-product-flysmart');
                        break;
                    }
                }
            }

            if (!section && packages.productflyultras && packages.productflyultras.length > 0) {
                for (let i = 0; i < packages.productflyultras.length; i++) {
                    let p = packages.productflyultras[i];
                    if (p.is_available) {
                        section = document.getElementById('section-product-flyultra');
                        break;
                    }
                }
            }

            console.log('section: ', section);
            if (section)
                section.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "start"
                });
        }
    }, [showModal, packages])

    useEffect(() => {
        if (props.packageConfirmation) {
            console.log("packageConfirmation: ", props.packageConfirmation)
            stepsControl.goToStepByName(STEPS_REGISTER.package_confirmation);
        }
    }, [props.packageConfirmation])

    useEffect(() => {
        if (choosePackage) {
            stepsControl.goToStepByName(STEPS_REGISTER.package);
        }
    }, [choosePackage])

    // useEffect(() => {
    //     stepsControl.goToStepByName(STEPS_REGISTER.done);
    // }, [])

    const onSelectAddress1Map = (address) => {
        props.setAddress1Map(address)
        // setChoosePackage(false) //comment beacuse 1map call 2 times on this functions
    }
    const stepsControl = useSteps(steps);
    console.log("AAAA stepsControl: ", stepsControl)
    console.log("AAAA props.choosePackage: ", props.choosePackage)
    return (
        <Container>
            <Grid item xs={12}>
                <CustomHeader />
                <div style={{ marginTop: 80 }}>
                    <HashLink to="#check_coverage" id='tag-check-coverage' style={{ display: 'none' }}>Check Coverage</HashLink>
                    <HashLink to="#packages" id='tag-packages' style={{ display: 'none' }}>Packages</HashLink>
                </div>
                <Grid xs={12} item container justifyContent="center">
                    <Grid xs={11} sm={11} md={11} lg={8} xl={6} item container justifyContent="center" id="check_coverage">
                        <CustomDivider />
                        <Grid xs={12} item container justifyContent="center">
                            <SimpleSteps
                                steps={steps}
                                step={stepsControl.step}
                                nextStep={stepsControl.nextStep}
                                prevStep={stepsControl.prevStep}
                                goToStep={stepsControl.goToStep}
                            />
                        </Grid>
                        <Grid item xs={12} backgroundColor={palette.common.white} borderRadius={theme.spacing(3)}>
                            {steps[stepsControl.step] === STEPS_REGISTER.address &&
                                <>
                                    <Typography paddingY={2} variant='h1' textAlign="center" fontWeight={500} color={palette.primary.main}>{t('enter_your_address_below')}</Typography>
                                    <OneMapWidget onSelect={onSelectAddress1Map} />
                                </>}
                            {steps[stepsControl.step] === STEPS_REGISTER.package && (
                                <Grid xs={12} item container paddingBottom={2} position="relative" paddingX={4}>
                                    <StepHeader
                                        title={t('choose_your_package')}
                                        palette={palette}
                                        onBack={() => stepsControl.goToStepByName(STEPS_REGISTER.address)}
                                    />
                                    <Grid xs={12} item container justifyContent="center">
                                        <SelectPackages
                                            packages={packages}
                                            addressSelected={props.addressSelected}
                                            onClickItem={props.onSelectPackage}
                                            choosePackage={choosePackage}
                                            packagesRef={packagesRef}
                                        />
                                    </Grid>
                                </Grid>
                            )}
                            {steps[stepsControl.step] === STEPS_REGISTER.registration && <RegisterControllerV3 stepsControl={stepsControl}/>}
                            {stepsControl.virtualStep === STEPS_REGISTER.rica_verification && <RegisterControllerV3 tab={'address_info'} stepsControl={stepsControl}/>}
                            {stepsControl.virtualStep === STEPS_REGISTER.package_confirmation &&
                                <Grid xs={12} item container paddingBottom={2} position="relative" paddingX={4}>
                                    <StepHeader
                                        title={t('confirmation')}
                                        palette={palette}
                                        onBack={() => stepsControl.goToStepByName(STEPS_REGISTER.package)}
                                    />
                                    <Grid container alignItems="center" justifyContent="center">
                                        <PackageInfoController stepsControl={stepsControl} />
                                    </Grid>
                                </Grid>
                            }
                            {steps[stepsControl.step] == STEPS_REGISTER.payment && <ChooseBillingDate stepsControl={stepsControl}/>}
                            {stepsControl.virtualStep == STEPS_REGISTER.billing_date && <PaymentSetupView stepsControl={stepsControl}/>}
                            {stepsControl.virtualStep == STEPS_REGISTER.place_order && <PlaceOrderController stepsControl={stepsControl}/>}
                            {steps[stepsControl.step] == STEPS_REGISTER.done && <OrderCompleteView stepsControl={stepsControl}/>}
                        </Grid>
                    </Grid>
                </Grid>
                {/* <CustomFooter /> */}
                {showModal && steps[stepsControl.step] == STEPS_REGISTER.address && <CustomAlert
                    open={showModal}
                    color={palette.primary.main}
                    // title={props.addressSelected?.pre_order_allowed ? t('pre_order_coverage') : t('has_coverage')}
                    isConfirm={true}
                    isConfirmFW={true}
                    showButtonClose={false}
                    customMessage={<ContentHasCoverage t={t} classes={classes} onShowTerm={props.onShowTerm} setShowModal={props.setShowModal} content={content} urlTerm={urlTerm} addressSelected={props.addressSelected} />}
                    onClose={() => {
                        props.setAddressSelected(null);
                        setShowModal(false)
                        setChoosePackage(false);
                    }}
                    confirmAction={{
                        okAction: () => {
                            setChoosePackage(true);
                            setShowModal(false);
                            stepsControl.goToStepByName(STEPS_REGISTER.package);
                        },
                        okTitle: t('btn_agree_continue'),
                    }}
                />}
                {showTerm && <TermConditionController
                    open={showTerm}
                    onClose={() => props.onShowTerm(false)}
                />}
                {showListAddresses && <ListAddresses
                    open={showListAddresses}
                    maxWidth={'md'}
                    title={t('please_select_address')}
                    addresses={props.addresses}
                    addressSelected={props.addressSelected}
                    setAddressSelected={props.setAddressSelected}
                    addressInfor={props.addressInfor}
                    onCheckCoverageLatLongV3={props.onCheckCoverageLatLongV3}
                    onClose={() => {
                        props.setAddressSelected(null);
                        setShowModal(false)
                        setShowListAddresses(false)
                    }}
                    confirmAction={() => setShowListAddresses(false)}
                />}
                <CustomModal
                    open={openModalBuilding}
                    handleClose={onCloseModalBuilding}
                    maxWidth={600}
                >
                    <Box padding="20px">
                        <Typography variant='h6'>Please select building</Typography>
                        <Box mt={"10px"}>
                            {building.map((item, index) => {
                                return <Box onClick={() => onSetBuildingSelected(item)} padding={"10px 15px"} sx={{
                                    '&:hover': {
                                        backgroundColor: '#dddddd',
                                    },
                                    cursor: "pointer"
                                }} borderTop={index == 0 ? "none" : "1px dashed #dddddd"}>
                                    <Typography>{item.DISPLAY_NAME}</Typography>
                                </Box>
                            })}

                        </Box>
                    </Box>

                </CustomModal>
            </Grid>
        </Container>
    )
}

function ContentHasCoverage(props) {
    const { palette } = useTheme();
    const { t, classes, content, urlTerm } = props;

    return (
        <Grid item xs={12}>
            <Typography variant="h5" color={palette.primary.main} style={{ textAlign: 'center', fontWeight: 'bold' }}>{props.addressSelected?.pre_order_allowed ? t('available_address_fre_order') : t('available_address')}</Typography>
        </Grid>
    )
}

function ContentHasCoverageOld(props) {
    const { palette } = useTheme();
    const { t, classes, content, urlTerm } = props;
    let _urlTerm = urlTerm && urlTerm.includes('http') ? urlTerm : 'https://' + urlTerm;
    return (
        <Grid item xs={12}>
            {props.addressSelected?.pre_order_allowed ? <>
                {urlTerm ? <Typography component={'a'} variant="subtitle2" color={palette.primary.main} href={urlTerm} target='_blank'>{t('pre_order_coverage_select_package')}</Typography> : <Typography variant="subtitle2" color={palette.primary.main}>{t('pre_order_coverage_select_package')}</Typography>}
            </> : <>
                <Typography variant="subtitle2" color={palette.primary.main}>{t('can_select_package')}</Typography>
                <Typography variant="subtitle2" color={palette.primary.main}>{t('agree_term')}
                    <strong>{content ? <span className={classes.term_condition}
                        onClick={() => {
                            props.onShowTerm(true);
                            props.setShowModal(false)
                        }}> </span>
                        : <a href={_urlTerm} style={{ color: '#3465A4' }} target={'_blank'}>{urlTerm}</a>
                    }
                    </strong>
                    {t('of_service')}
                </Typography>
            </>}
        </Grid>
    );
}

function SelectPackages(props) {
    console.log('LandingPageView SelectPackages props = ', props);
    const { packages, choosePackage, addressSelected } = props;
    const { palette } = useTheme();
    const { t } = useTranslation();
    const isPackageAvailable = (item, addressSelected) => {
        let is_available = item.is_available && addressSelected && addressSelected.product_types?.includes(item.product_type_code);
        if (item.code === "BASE-PREPAID-10-10") {
            is_available = !!(addressSelected && addressSelected.tactical);
        }
        return is_available;
    };
    const flyliteAvailable = packages?.productflylites?.filter(item => isPackageAvailable(item, addressSelected)) || [];
    const flysmartAvailable = packages?.productflysmarts?.filter(item => isPackageAvailable(item, addressSelected)) || [];
    const flyultraAvailable = packages?.productflyultras?.filter(item => isPackageAvailable(item, addressSelected)) || [];
    return (
        <Grid xs={11} sm={11} md={11} lg={8} xl={6} item container justifyContent="center" textAlign={'center'} id="packages" ref={props.packagesRef}>
            {flyliteAvailable.length > 0 && <Grid item xs={12} id="section-product-flylite">
                <GroupTitle title={t('flylite_packages')} desc={t('package_availability')}>
                    <Packages
                        packages={packages.productflylites}
                        onClickItem={props.onClickItem}
                        addressSelected={addressSelected}
                    />
                </GroupTitle>
            </Grid>}
            {flysmartAvailable.length > 0 && <Grid item xs={12} id="section-product-flysmart">
                <GroupTitle title={t('flysmart_packages')} desc={t('package_availability')}>
                    <Packages
                        packages={packages.productflysmarts}
                        onClickItem={props.onClickItem}
                        addressSelected={addressSelected}
                    />
                </GroupTitle>
            </Grid>}
            {flyultraAvailable.length > 0 && <Grid item xs={12} id="section-product-flyultra">
                <GroupTitle title={t('flyultra_packages')} desc={t('package_availability')}>
                    <Packages
                        packages={packages.productflyultras}
                        onClickItem={props.onClickItem}
                        addressSelected={addressSelected}
                    />
                </GroupTitle>
            </Grid>}
        </Grid>
    )
}

// function Packages(props) {
//     const { packages, choosePackage, addressSelected } = props;
//     const classes = useStyles();
//     return (
//         <Grid xs={12} item container direction="row" justifyContent={'center'} spacing={2}>
//             {packages.map((item, index) => {
//                 let is_available = item.is_available && addressSelected && addressSelected.product_types.includes(item.product_type_code) ? true : false;
//                 // is_available = true;
//                 return (
//                     <Grid key={index} xs={6} sm={6} md={6} lg={3} className={is_available ? classes.canSelected : classes.cantSelected} item onClick={is_available ? () => props.onClickItem(item) : () => { }} title={item.product && item.product.name ? item.product.name : null}>
//                         {item.image_url ? <img className={classNames(classes.item_image, !is_available ? classes.img_cant_select : undefined)} src={item.image_url} />
//                             : <img className={classNames(classes.item_image_logo, !is_available ? classes.img_cant_select : undefined)} src={getLogo()} />}
//                     </Grid>
//                 )
//             })}
//         </Grid>
//     )
// }

function Packages(props) {
    console.log('LandingPageView Packages---------- props: ', props);
    const { packages, choosePackage, addressSelected } = props;
    const classes = useStyles();
    const { t } = useTranslation();
    // console.log("packages===", packages);
    return (
        <Grid xs={12} item container direction="row" justifyContent={'center'} spacing={2}>
            {packages.map((item, index) => {
                // let is_available = item.product_type == 'openserve' ? item.is_available : choosePackage;
                let is_available = item.is_available && addressSelected && addressSelected.product_types.includes(item.product_type_code) ? true : false;
                // is_available = true;
                if (item.code === "BASE-PREPAID-10-10") {
                    if (addressSelected && addressSelected.tactical) is_available = true;
                    else is_available = false;
                }
                if (!is_available) return null;
                return (
                    <Grid key={index} xs={6} sm={6} md={6} lg={3} className={is_available ? classes.canSelected : classes.cantSelected} item onClick={is_available ? () => props.onClickItem(item) : () => { }} title={item.product && item.product.name ? item.product.name : null}>
                        {item.image_url ? <img className={classNames(classes.item_image, !is_available ? classes.img_cant_select : undefined)} src={item.image_url} />
                            : <img className={classNames(classes.item_image_logo, !is_available ? classes.img_cant_select : undefined)} src={getLogo()} />}
                        {item.code === "BASE-PREPAID-10-10" && !is_available && <Typography variant='contained' style={{ color: theme.palette.common.red }}>{t('oct10_not_available_in_all_areas')}</Typography>}
                    </Grid>
                )
            })}
        </Grid>
    )
}

function GroupTitle(props) {
    const { t } = useTranslation();
    let { title, desc, children } = props
    const { palette } = useTheme();
    return <Box marginTop={3} >
        <Typography mb={1} textAlign={"center"} variant='h6'>{title}</Typography>
        {children}
        <Typography mt={2} textAlign={"center"} color={palette.primary.main}>{desc}</Typography>
    </Box>
}
